// @ts-ignore
// import HoverSoundEffect from "../assets/sound/mechanical-hover.mp3";

// play sound
export const playHoverSound = () => {
  // new Audio(HoverSoundEffect)?.play();
};
